import React, { PureComponent } from "react";

export default class Separator extends PureComponent {
  render() {
    return <hr className="af-separator" />;
  }
}
